import React from 'react';
import styled from 'styled-components';
import Header from './Components/Header';
import { useTranslation } from 'react-i18next';
import ActivateNow from './Components/ActivateNow';
import { useQuery } from '../Common/Hooks';

interface AndroidInterface {
  navigateToSettings(): void;
  close(): void;
}

declare const KindredAndroid: AndroidInterface | undefined;

const Container = styled.div`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  flex: 1;
`;

const BottomContent = styled.div`
  flex-direction: column;
  padding-bottom: 24px;
`;

const AndroidAccessibility: React.FC = () => {
  const query = useQuery();
  const permissionsAgreed = (query.get('accepted') as string) === 'true';
  const { t } = useTranslation();

  const navigateToSettings = () => {
    if (
      typeof KindredAndroid !== 'undefined' &&
      KindredAndroid.navigateToSettings
    ) {
      KindredAndroid.navigateToSettings();
    }
  };

  const close = () => {
    if (typeof KindredAndroid !== 'undefined' && KindredAndroid.close) {
      KindredAndroid.close();
    }
  };

  return (
    <Container>
      <Header
        permissionsAgreed={permissionsAgreed}
        disclaimerText={t(
          'extension.itvActivation.androidAccessibility.disclaimer'
        )}
        title={t(
          `extension.itvActivation.androidAccessibility.${
            permissionsAgreed ? 'activatedTitle' : 'title'
          }`
        )}
      />
      <BottomContent>
        <ActivateNow
          cashSaverPopUpMsg={t(
            'extension.itvActivation.androidAccessibility.cashSaverPopUp'
          )}
          navigateToSettings={navigateToSettings}
          close={close}
          permissionsAgreed={permissionsAgreed}
          title={t(
            'extension.itvActivation.androidAccessibility.activateNowTitle'
          )}
          msg={t('extension.itvActivation.androidAccessibility.activateNowMsg')}
          steps={[
            t('extension.itvActivation.androidAccessibility.activateNowStep1'),
            t('extension.itvActivation.androidAccessibility.activateNowStep2'),
            t('extension.itvActivation.androidAccessibility.activateNowStep3'),
          ]}
        />
      </BottomContent>
    </Container>
  );
};

export default AndroidAccessibility;
